import { z } from 'zod';
import { capabilitiesSchema, openingHoursSchema, staffLevelsSchema } from './garages';
import { emailSchema, phoneSchema } from './common';

export const createLocationSchema = z.object({
  label: z.string().trim().min(1).max(100),
  addressLine1: z.string().trim().min(1).max(200),
  addressLine2: z.string().trim().max(200).nullable().optional(),
  city: z.string().trim().min(1).max(100),
  postcode: z.string().trim().min(2).max(20),
  phone: phoneSchema.nullable().optional(),
  email: emailSchema.nullable().optional(),
  openingHours: openingHoursSchema.nullable().optional(),
  capabilities: capabilitiesSchema.default([]),
  staffLevels: staffLevelsSchema.default({}),
  lkqAccountNumber: z.string().trim().max(50).nullable().optional(),
});
export type CreateLocationPayload = z.infer<typeof createLocationSchema>;

// Update derives from create (commandment 14)
export const updateLocationSchema = createLocationSchema.partial();
export type UpdateLocationPayload = z.infer<typeof updateLocationSchema>;
